export default {"src":"/_next/static/media/walking_tours.a467510f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};